/** @format */

import template from './gb-raffle-winners-widget.html';
import './gb-raffle-winners-widget.scss';

export const GbRaffleWinnersWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
        gbWidget: '^^',
    },
    controller: class GbRaffleWinnersWidgetComponent {
        constructor($log, $ccRealtime, $gbRaffleDraw, $timeout, $interval, $translate, $rootScope) {
            'ngInject';

            this.$log = $log;
            this.$ccRealtime = $ccRealtime;
            this.$gbRaffleDraw = $gbRaffleDraw;
            this.$timeout = $timeout;
            this.$interval = $interval;
            this.$rootScope = $rootScope;
            this.$translate = $translate;

            this.pageSize = 5;
            this.firstPrizeShowingIndex = 0;
            this.pageShowTime = 10000;
            this.raffleDraws = [];
        }

        cancelPageRotation() {
            if (this.pageRotationInterval) {
                this.$interval.cancel(this.pageRotationInterval);
            }
        }

        startPageRotation() {
            this.cancelPageRotation();

            this.pageRotationInterval = this.$interval(() => {
                let newIndex = this.firstPrizeShowingIndex + this.pageSize;
                if (newIndex >= this.getRaffleDraws().length) {
                    newIndex = 0;
                }

                this.firstPrizeShowingIndex = newIndex;
            }, this.pageShowTime);
        }

        // Finds the page that the raffle draw should be a part of, and returns the
        // index of the first raffle draw on that page.
        getRaffleDrawPageStartIndex(raffleDraw) {
            let raffleDrawIndex = this.getRaffleDraws().findIndex((draw) => {
                return raffleDraw.prize === draw.prize;
            });

            let pageStartIndex = Math.floor(raffleDrawIndex / this.pageSize) * this.pageSize;

            return pageStartIndex;
        }

        getCachedRaffleDraws() {
            return this.$gbRaffleDraw.cache.query({
                auction: this.gbApp.getAuctionUrl(),
                raffle_item: this.gbWidget.widget.raffle_item,
            });
        }

        setRaffleDraws() {
            if (!this.gbApp.isEditMode()) {
                this.raffleDraws = this.getCachedRaffleDraws().sort((a, b) => {
                    return a.prize - b.prize;
                });
            }
        }

        getRaffleDraws() {
            return this.raffleDraws;
        }

        updatePage() {
            this.updateTimeout = this.$timeout(() => {
                this.setRaffleDraws();
                this.firstPrizeShowingIndex = this.getRaffleDrawPageStartIndex(this.currentDraw);
                this.startPageRotation();
                this.updateTimeout = null;
            }, this.gbPresenter.raffleDrawSpinTime);
        }

        $onInit() {
            this.$timeout(() => {
                this.setRaffleDraws();
            });

            this.startPageRotation();

            this.newRaffleDrawHandler = (ev, data) => {
                if (data.raffle_item === this.gbWidget.widget.raffle_item) {
                    this.$log.info('Ticket drawn for raffle item', data);

                    if (this.updateTimeout && this.currentDraw.uuid !== data.uuid) {
                        this.setRaffleDraws();
                        this.$timeout.cancel(this.updateTimeout);
                        this.updateTimeout = null;
                    }

                    this.currentDraw = data;
                    this.updatePage();
                }
            };

            this.$ccRealtime.on(this.$gbRaffleDraw.cache.opts.pusher_create, this.newRaffleDrawHandler);

            this.setPreviewListener();
        }

        $onDestroy() {
            this.cancelPageRotation();
        }

        setPreviewListener() {
            if (this.gbApp.isEditMode()) {
                this.$rootScope.$on(this.gbApp.$raffleWinnerPreviewEvent, (event, raffleDraw) => {
                    raffleDraw.prize = this.raffleDraws.length + 1;
                    if (!this.raffleDraws.includes(raffleDraw)) {
                        this.raffleDraws.push(raffleDraw);
                    }
                });
            }
        }
    },
};
